import { SET_SAVE_BOOK_FLAG } from '../../action-types/ui/isSavedBook';

export const isSavedBook = flag => ({
  type: SET_SAVE_BOOK_FLAG,
  flag,
});



// WEBPACK FOOTER //
// ./src/redux/actions/ui/isSavedBook.js